"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
require("../../../css/components/accessibility/Button.scss");
const Button = (_a) => {
    var { title, icon, variant = 'primary' } = _a, attributes = __rest(_a, ["title", "icon", "variant"]);
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement("button", Object.assign({ type: "button", className: `btn-generic--${variant}` }, attributes),
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: "mr-2", icon: icon }),
        t(title)));
};
exports.default = Button;
